import { Component } from "@angular/core";

@Component({
  selector: 'app-informacoes-complementares-menu',
  templateUrl: './informacoes-complementares-menu.component.html',
  styleUrls: ['./informacoes-complementares-menu.component.scss']
})
export class InformacoesComplementaresMenuComponent {

}